(function initVehicleCostPolicy(global) {
  const tr = (key) => (typeof global.t === 'function' ? global.t(key) : key);
  const MODES = new Set(['vat_deductible', 'no_vat_deduction', 'manual_review']);
  const isoDate = (value) => /^\d{4}-\d{2}-\d{2}$/.test(String(value || '')) ? String(value) : '';

  const normalize = (policy) => ({
    version: 1,
    periods: (Array.isArray(policy?.periods) ? policy.periods : [])
      .map((period) => ({
        id: String(period?.id || ''),
        mode: MODES.has(period?.mode) ? period.mode : 'manual_review',
        validFrom: isoDate(period?.validFrom),
        validTo: isoDate(period?.validTo),
        responsibilityAccepted: period?.responsibilityAccepted === true,
        confirmedAt: String(period?.confirmedAt || ''),
        confirmedByUserId: String(period?.confirmedByUserId || ''),
      }))
      .filter((period) => period.validFrom)
      .sort((left, right) => left.validFrom.localeCompare(right.validFrom)),
  });

  const activeForDate = (policy, date) => {
    const effectiveFor = isoDate(date);
    if (!effectiveFor) return null;
    return normalize(policy).periods
      .filter((period) => period.validFrom <= effectiveFor && (!period.validTo || effectiveFor < period.validTo))
      .sort((left, right) => right.validFrom.localeCompare(left.validFrom))[0] || null;
  };

  const isFuelAnalysis = (analysis) => {
    const ruleId = String(analysis?.accountingRule?.ruleId || '');
    if (ruleId === 'NO.RECEIPT.FUEL.VAT_REVIEW.V1' || ruleId === 'NO.RECEIPT.VEHICLE_SERVICE.VAT_REVIEW.V1') return true;
    const accountCode = String(analysis?.suggestedCostAccountCode || '');
    return accountCode === '7000' || accountCode === '7020';
  };

  const promptState = ({ analysis, policy } = {}) => {
    if (!isFuelAnalysis(analysis) || !analysis?.receiptDate) return 'none';
    const activePeriod = activeForDate(policy, analysis.receiptDate);
    if (!activePeriod) return 'choose';
    const decision = analysis?.vehicleCostPolicyDecision;
    if (!decision) return 'refresh';
    const decisionPeriod = decision.period || {};
    if (decisionPeriod.validFrom && decisionPeriod.validFrom !== activePeriod.validFrom) return 'refresh';
    if (decisionPeriod.mode && decisionPeriod.mode !== activePeriod.mode) return 'refresh';
    if (activePeriod.mode !== 'manual_review' && activePeriod.responsibilityAccepted && !decision.automatic) return 'refresh';
    return 'none';
  };

  const applySelection = (policy, selection, metadata = {}) => {
    const validFrom = isoDate(selection?.validFrom);
    const mode = MODES.has(selection?.mode) ? selection.mode : '';
    if (!validFrom || !mode) throw new Error(tr('r1e.vehiclePolicy.pickDateAndMode'));
    if (mode !== 'manual_review' && selection?.responsibilityAccepted !== true) {
      throw new Error(tr('r1e.vehiclePolicy.confirmResponsibility'));
    }

    const existing = normalize(policy).periods;
    const futureStart = existing
      .map((period) => period.validFrom)
      .filter((date) => date > validFrom)
      .sort()[0] || '';
    const periods = existing
      .filter((period) => period.validFrom !== validFrom)
      .map((period) => period.validFrom < validFrom && (!period.validTo || validFrom < period.validTo)
        ? { ...period, validTo: validFrom }
        : period);
    periods.push({
      id: String(metadata.id || `vehicle-policy-${Date.now()}`),
      mode,
      validFrom,
      validTo: futureStart,
      responsibilityAccepted: selection?.responsibilityAccepted === true,
      confirmedAt: String(metadata.confirmedAt || new Date().toISOString()),
      confirmedByUserId: String(metadata.confirmedByUserId || ''),
    });
    return normalize({ version: 1, periods });
  };

  global.PlummeVehicleCostPolicy = { normalize, activeForDate, isFuelAnalysis, promptState, applySelection };
})(window);
